export default __webpack_public_path__ + "static/media/Red.8b7b3c7c.svg";